/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_A1Inputs */

const en_guide_large_json_files_faq_a1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on your browser and device memory. Most modern browsers handle files up to 50 MB without issues. For larger files, use command-line tools like jq.`)
};

const ko_guide_large_json_files_faq_a1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저와 기기 메모리에 따라 다릅니다. 대부분의 최신 브라우저는 50 MB까지의 파일을 문제없이 처리합니다. 더 큰 파일은 jq 같은 커맨드 라인 도구를 사용하세요.`)
};

const ja_guide_large_json_files_faq_a1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザとデバイスのメモリに依存します。ほとんどの現代的なブラウザは50MBまでのファイルを問題なく処理できます。それ以上のファイルには、jqなどのコマンドラインツールを使用してください。`)
};

/**
* | output |
* | --- |
* | "It depends on your browser and device memory. Most modern browsers handle files up to 50 MB without issues. For larger files, use command-line tools like jq." |
*
* @param {Guide_Large_Json_Files_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_a1 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_a1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_a1(inputs)
	return ja_guide_large_json_files_faq_a1(inputs)
});